module.exports = __webpack_public_path__ + "img/3-1.89e35370.svg";